import React from "react";
import { IconButton } from "@mui/material";
import OpenInFullIcon from "@mui/icons-material/OpenInFull";
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen";
import { ChatCommandRouterServer } from "./types";
import useTheme from "../../common/hooks/useTheme";
import classes from "./Chat.module.css";

type Props = {
  surfaceId: string;
  isExpanded: boolean;
  onToggleExpanded: () => void;
  showDevControls: boolean;
  showEnvironmentSelector: boolean;
  commandRouterServer: ChatCommandRouterServer;
  onCommandRouterServerChange: (server: ChatCommandRouterServer) => void;
};

const ChatHeader = ({
  surfaceId,
  isExpanded,
  onToggleExpanded,
  showDevControls,
  showEnvironmentSelector,
  commandRouterServer,
  onCommandRouterServerChange,
}: Props) => {
  const theme = useTheme();

  return (
    <header className={classes.header}>
      <div className={classes.headerMainRow}>
        <div className={classes.headerIdentity}>
          <h3 className={classes.headerTitle}>Assistant Mock</h3>
          <p className={classes.headerSubtitle}>{surfaceId}</p>
        </div>
        <div className={classes.headerActionGroup}>
          <IconButton
            size="small"
            aria-label={
              isExpanded ? "Collapse chat panel" : "Expand chat panel"
            }
            onClick={onToggleExpanded}
            sx={{
              border: `1px solid ${theme.colors_ds.NEUTRAL_BORDER_WEAK}`,
              color: theme.colors_ds.NEUTRAL_ICON_STRONG,
              backgroundColor: theme.colors_ds.NEUTRAL_BG_MAIN,
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: theme.colors_ds.NEUTRAL_BG_ELEVATION1,
              },
            }}
          >
            {isExpanded ? (
              <CloseFullscreenIcon fontSize="small" />
            ) : (
              <OpenInFullIcon fontSize="small" />
            )}
          </IconButton>
        </div>
      </div>

      {showDevControls && (
        <>
          {showEnvironmentSelector && (
            <div className={classes.devTopControls}>
              <label className={classes.devControlGroup}>
                <span className={classes.devLabel}>Server</span>
                <select
                  className={classes.devSelect}
                  value={commandRouterServer}
                  onChange={(event) =>
                    onCommandRouterServerChange(
                      event.target.value as ChatCommandRouterServer
                    )
                  }
                  aria-label="Select chat command router server"
                >
                  <option value="prod">Prod</option>
                  <option value="dev">Dev</option>
                </select>
              </label>
            </div>
          )}
        </>
      )}
    </header>
  );
};

export default ChatHeader;
